module.exports = __webpack_public_path__ + "static/img/sw-issue.6d4995c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/sw-issue.svg
// module id = syHi
// module chunks = 4